export default "__VITE_ASSET__D73SNYd9__"